import {
  HIDE_ERROR,
  SHOW_ERROR,
  HIDE_LOADER,
  SHOW_LOADER,
  SHOW_TOAST,
  HIDE_TOAST,
} from '../actions/types';

const initialState = {
  errorMessage: '',
  toastMessage: '',
  showLoader: false,
};

export default function app(state = initialState, { type, payload }) {
  switch (type) {
    case HIDE_ERROR:
      return { ...state, errorMessage: '' };

    case SHOW_ERROR:
      const { message: errorMessage } = payload;
      return { ...state, errorMessage };

    case SHOW_TOAST:
      const { message: toastMessage } = payload;
      return { ...state, toastMessage };

    case HIDE_TOAST:
      return { ...state, toastMessage: '' };

    case HIDE_LOADER:
      return { ...state, showLoader: false };

    case SHOW_LOADER:
      return { ...state, showLoader: true };

    default:
      return state;
  }
}
